// External dependencies
import { __ } from "@wordpress/i18n";
import { registerBlockType } from "@wordpress/blocks";
import { Fragment } from "@wordpress/element";
import { PanelBody, SelectControl } from "@wordpress/components";
import { RichText, InspectorControls } from "@wordpress/block-editor";
// import { MediaPlaceholder, RichText, BlockControls, MediaReplaceFlow } from "@wordpress/block-editor";
import AttributesEditor from '../components/Gutenberg/AttributesEditor'
import Button from '../components/Button/Button.edit'

// Internal dependencies
import ServiceCTA from "../components/ServiceCTA/ServiceCTA";

const backgroundOptions = [{ label: 'White', value: 'white' }, { label: 'Apricot', value: 'apricot' }]

// Block attributes (custom props)
const blockAttributes = {
    headline: {
        type: 'string',
        default: ''
        // default: "We work with you and the law to protect wildlife, culture, community and country."
    },
    description: {
        type: 'string',
        default: ''
        // default: "Our legal resources are designed to help you understand your rights and responsibilities in environmental matters and empower you to take the next step on important issues."
    },
    cta1: {
        type: 'object',
        default: null
        // default: "Find legal resources"
    },
    cta2: {
        type: 'string',
        default: ''
        // default: "Apply for legal advice"
    },
    background: {
        enum: backgroundOptions.map(({ value }) => value),
    }
}

// Edit function (responsible for wp-admin post edit screen)
const edit = ({ setAttributes, attributes }) => {
    const { headline, description, cta1, cta2, background } = attributes;

    return (
        <Fragment>
            <InspectorControls>
                <PanelBody title={__('')}>
                    <AttributesEditor blockAttributes={blockAttributes} attributes={attributes} setAttributes={setAttributes} />
                    <SelectControl
                        label={__('Colour')}
                        labelPosition="top"
                        options={backgroundOptions}
                        value={background}
                        onChange={(value) => setAttributes({ background: value })}
                    />
                </PanelBody>
            </InspectorControls>

            <ServiceCTA
                background={background}
                style={{ width: '100%', marginLeft: 0 }}
                primaryText={<RichText
                    value={headline}
                    onChange={(headline) => setAttributes({ headline })}
                    placeholder={__('Headline', 'service-cta')}
                    multiline={false}
                    inlineToolbar={false}
                    tagName="span"
                    allowedFormats={[]}
                    keepPlaceholderOnFocus
                />}
                secondaryText={<RichText
                    value={description}
                    onChange={(description) => setAttributes({ description })}
                    placeholder={__('Description', 'service-cta')}
                    multiline={false}
                    inlineToolbar={false}
                    tagName="span"
                    allowedFormats={[]}
                    keepPlaceholderOnFocus
                />}
                cta1={<Button value={cta1} onChange={(cta1) => setAttributes({ cta1 })} />}
                // cta1={<RichText
                //     value={cta1.text}
                //     multiline={false}
                //     inlineToolbar={false}
                //     onChange={(value) => setAttributes({ cta1: { text: value.replace(/<\/?a[^>]*>/g, ''), url: getUrl(value) } })}
                //     placeholder={__('Primary CTA', 'service-cta')}
                //     allowedFormats={['core/link']}
                //     keepPlaceholderOnFocus
                // />}
                cta2={<RichText
                    value={cta2}
                    onChange={(cta2) => setAttributes({ cta2 })}
                    placeholder={__('Second CTA', 'service-cta')}
                    allowedFormats={['core/link']}
                    keepPlaceholderOnFocus
                />}
            />
        </Fragment>
    );
}

// Save function (responsible for static HTML saved in database)
const save = ({ attributes }) => {
    const { headline, description, cta1, cta2, background } = attributes;

    return (
        <ServiceCTA
            background={background}
            primaryText={<RichText.Content value={headline} />}
            secondaryText={<RichText.Content value={description} />}
            cta1={<Button.Content value={cta1} />}
            cta2={<RichText.Content value={cta2} />}
        />
    );
}

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/#registering-a-block
 */
registerBlockType("mt/gutenberg-service-cta", {

    /**
     * This is the display title for your block, which can be translated with `i18n` functions.
     * The block inserter will show this name.
     */
    title: __("Service CTA", "gutenberg-service-cta"),

    /**
     * An icon property should be specified to make it easier to identify a block.
     * These can be any of WordPress’ Dashicons, or a custom svg element.
     */
    icon: "align-pull-left",

    /**
     * Blocks are grouped into categories to help users browse and discover them.
     * The categories provided by core are `common`, `embed`, `formatting`, `layout` and `widgets`.
     */
    category: "widgets",

    /**
     * Optional block extended support features.
     */
    // supports: {
    //     // Removes support for an HTML mode.
    //     html: false
    // },
    attributes: blockAttributes,

    /**
     * The edit function describes the structure of your block in the context of the editor.
     * This represents what the editor will render when the block is used.
     *
     * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#edit
     *
     * @param {Object} [props] Properties passed from the editor.
     *
     * @return {WPElement} Element to render.
     */
    edit,

    /**
     * The save function defines the way in which the different attributes should be combined
     * into the final markup, which is then serialized by the block editor into `post_content`.
     *
     * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#save
     *
     * @return {WPElement} Element to render.
     */
    save
});
